// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import uuid from "react-native-uuid";

// Components Imports
// import { Button, Label, Input, Toastr } from "@revvsales/components";
import { Button, Label, Input } from "@revvsales/components";

// Actions Imports
import { DocumentTemplateActions } from "../../../actions";
import {
  executeCommand,
  updateDocumentComponentAction,
} from "../../../actions/DocumentActions";
import ImageFieldCommand from "../../../commands/imageFieldCommand";

// Destructuring
const {
  nukeImageFormField,
  addDynamicFieldinListAsync,
  updateImageFormFieldAndSection,
  toggleDynamicFieldView,
} = DocumentTemplateActions;

class ImageFormFieldSidePanel extends Component {
  state = {
    id: null,
    name: "",
    description: "",
    type: "single_select",
    imageFormFields: [],
    defaultValue: null,
    defaultValueCheckbox: false,
    errMsg: null,
    oldImageFieldInfo: null, // is being used for undo/redo purpose
  };

  componentDidMount() {
    this._updateClauseParams(this.props.clause, this.props.section);
  }

  _handleInputChange = (event, type) => {
    if (event && event.target) {
      if (type === "defaultValueCheckbox") {
        this.setState(prevState => ({
          defaultValueCheckbox: !prevState.defaultValueCheckbox,
          errMsg: null,
        }));
      } else {
        this.setState({ [type]: event.target.value, errMsg: null });
      }
    }
  };

  _updateClauseParams = (clause, section) => {
    if (clause && clause.id) {
      const {
        id,
        label: name,
        description,
        meta: { subtype: type, default: defaultValue },
      } = clause;

      const imageFormFields = [
        {
          id: uuid.v4(),
          data: defaultValue,
        },
      ];
      this.setState({
        id,
        type,
        name,
        description,
        imageFormFields,
        defaultValue: defaultValue || section.data,
        defaultValueCheckbox: !!defaultValue,
        oldImageFieldInfo: {
          id,
          type,
          name,
          description,
          clauses: imageFormFields,
          defaultValue,
          isImageFormField: true,
        },
      });
    } else if (section) {
      const imageFormFields = [
        {
          id: uuid.v4(),
          data: section.data,
        },
      ];
      let { defaultValueCheckbox } = this.state;
      if (section && section.data) {
        defaultValueCheckbox = true;
      }
      this.setState({
        imageFormFields,
        defaultValueCheckbox,
        defaultValue: section.data,
      });
    }
  };

  _validateImageFormField = () => {
    const { type, name, description } = this.state;
    let errMsg;
    if (name === "" || description === "" || type === null) {
      errMsg = "Image form field name and description can't be empty.";
    }
    return errMsg;
  };

  _addField = () => {
    const { id, type, name, description, imageFormFields } = this.state;

    // Validate the clause options
    const errMsg = this._validateImageFormField();
    if (errMsg) {
      this.setState({ errMsg });
    } else {
      const imageField = {
        id,
        type,
        name,
        description,
        clauses: imageFormFields,
        defaultValue: null,
        isImageFormField: true,
      };

      if (this.state.defaultValueCheckbox) {
        imageField.defaultValue = this.state.defaultValue;
        imageField.clauses = [
          { id: imageField.clauses[0].id, data: this.state.defaultValue },
        ];
      } else {
        imageField.clauses = [{ id: imageField.clauses[0].id, data: "" }];
      }

      const imageFieldCommandObj = new ImageFieldCommand({
        id,
        imageField,
        blockID: this.props.blockID,
        blockType: this.props.blockType,
        components: this.props.components,
        updateComponent: this.props.updateComponent,
        fields: this.props.fields ? [...this.props.fields] : [],
        section: this.props.section ? { ...this.props.section } : {},
        addDynamicFieldinListAsync: this.props.addDynamicFieldinListAsync,
        oldImageFieldInfo: id ? { ...this.state.oldImageFieldInfo } : null,
        updateDocumentComponentAction: this.props.updateDocumentComponentAction,
        updateImageFormFieldAndSection: this.props
          .updateImageFormFieldAndSection,
        toggleDynamicFieldView: this.props.toggleDynamicFieldView,
      });
      this.props.executeCommand(imageFieldCommandObj);
    }
  };

  render() {
    let deafultCheckbox = true;
    if (
      typeof this.props.section.data === "string" &&
      this.props.section.data.length > 0
    ) {
      deafultCheckbox = false;
    }
    return (
      <div
        className="imageformfield-container"
        data-test="imageformfield-container">
        {/* --------------------------- Header Section --------------------------- */}
        <div
          className="imageformfield-header"
          data-test="imageformfield-header">
          <span
            className="imageformfield-header-back-button"
            data-test="imageformfield-header-back-button"
            onClick={this.props.nukeImageFormField}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}>
            <FontAwesomeIcon icon={["far", "angle-left"]} />
          </span>
          Convert image to placeholder image field
          <div
            className="imageformfield-action-btns"
            data-test="imageformfield-action-btns">
            <Button
              className="btn-transparent"
              data-test="imageformfield-discard-button"
              id="document-clause-options-id-discard-btn"
              onClick={this.props.nukeImageFormField}>
              Discard
            </Button>
            <Button
              onClick={this._addField}
              data-test="imageformfield-save-button"
              id="document-clause-options-id-save-btn">
              {this.props.clause ? "Update" : "Add"} field
            </Button>
          </div>
        </div>

        {/* --------------------------- Error Section --------------------------- */}
        <div>
          {this.state.errMsg && (
            <div
              className="error-message-container imageformfield-message-container"
              data-test="imageformfield-message-container">
              <div
                className="error-message-wrapper"
                data-test="imageformfield-error-message-wrapper">
                <span
                  className="error-message-icon"
                  data-test="imageformfield-error-message-icon">
                  <FontAwesomeIcon icon={["far", "times-circle"]} />
                </span>
                {this.state.errMsg}
              </div>
            </div>
          )}
        </div>

        {/* --------------------------- Form Section --------------------------- */}
        <div className="imageformfield-wrapper">
          <span
            className="imageformfield-description"
            data-test="imageformfield-description">
            Doing this will convert the selected image block into a placeholder.
            Users can upload their own image file here when creating documents
            from this template. If the created document is shared with someone
            for filling, the recipients can upload an image here too.
            <a
              href="https://www.revv.so/docs/how-do-i-create-an-image-placeholder-in-my-templates"
              rel="noopener noreferrer"
              target="_blank"
              className="image-field-learn-more"
              data-test="image-field-learn-more">
              Learn more here.
            </a>
          </span>

          <div
            className="imageformfield-form-row"
            data-test="imageformfield-form-row">
            <Label data-test="imageformfield-form-row">
              <span data-test="imageformfield-form-label">
                Field label
                <span className="imageformfield-required-form-field">*</span>
              </span>
            </Label>
            <div className="imageformfield-form-input">
              <Input
                autoFocus
                type="text"
                data-test="imageformfield-form-field-name-input"
                onChange={event => this._handleInputChange(event, "name")}
                isAutoFocus
                value={this.state.name}
                placeholder="Enter field name"
              />
            </div>
          </div>
          <div
            className="imageformfield-form-row"
            data-test="imageformfield-form-row">
            <Label data-test="imageformfield-form-row">
              <span data-test="imageformfield-form-desc-label">
                Field description
                <span className="imageformfield-required-form-field">*</span>
              </span>
            </Label>
            <div className="imageformfield-form-input">
              <Input
                type="text"
                data-test="imageformfield-form-field-desc-input"
                onChange={event =>
                  this._handleInputChange(event, "description")
                }
                value={this.state.description}
                placeholder="Enter field description"
              />
            </div>
          </div>
          <div
            className="imageformfield-form-row"
            data-test="imageformfield-form-row">
            <Label data-test="imageformfield-form-field-type">Field type</Label>
            <div className="imageformfield-form-input">
              <Input
                type="text"
                data-test="imageformfield-form-field-type-input"
                disabled
                placeholder="Single Image"
              />
            </div>
          </div>

          <div
            className="imageformfield-form-row"
            data-test="imageformfield-form-row">
            <Input
              id="imageformfield-form-type-default-checkbox"
              data-test="imageformfield-form-type-default"
              type="checkbox"
              checked={this.state.defaultValueCheckbox}
              disabled={deafultCheckbox}
              onChange={event =>
                this._handleInputChange(event, "defaultValueCheckbox")
              }
            />
            <Label
              htmlFor="imageformfield-form-type-default-checkbox"
              className="imageformfield-form-type-default"
              data-test="imageformfield-form-type-default-label">
              Use the selected image as default image
            </Label>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    imageFormField: { section, clause, blockType, blockID },
    dynamicFields: { fields },
    template: { fields_used: dynamicFieldsUsed },
  } = state.TemplateStore;

  const { components } = state.DocumentStore;

  // Create a map for fieldsUsed obj
  const fieldsUsed = {};
  dynamicFieldsUsed.forEach(field => {
    fieldsUsed[field.id] = field;
  });

  return {
    components,
    clause,
    fields,
    fieldsUsed,
    section,
    blockType,
    blockID,
  };
};

const mapDispatchToProps = {
  executeCommand,
  nukeImageFormField,
  toggleDynamicFieldView,
  addDynamicFieldinListAsync,
  updateImageFormFieldAndSection,
  updateDocumentComponentAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ImageFormFieldSidePanel);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/ImageFormFieldSidePanel/index.js